import { render, staticRenderFns } from "./taxPayment.vue?vue&type=template&id=d58d48b8&scoped=true"
import script from "./taxPayment.vue?vue&type=script&lang=js"
export * from "./taxPayment.vue?vue&type=script&lang=js"
import style0 from "./taxPayment.vue?vue&type=style&index=0&id=d58d48b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58d48b8",
  null
  
)

export default component.exports